import { VehicleController } from 'core/repositories/VehicleController';
import { createListenerManager } from 'infrastructure/utility/ListenerManager';

export class CombinedVehicleController implements VehicleController {
    private readonly eventListeners = createListenerManager<VehicleController.EventListener>();

    constructor(private controllers: VehicleController[]) {
        controllers.forEach(controller => {
            controller.addEventListener(event => {
                this.eventListeners.forEach(listener => listener(event));
            });
        });
    }

    addEventListener(listener: VehicleController.EventListener): void {
        this.eventListeners.addListener(listener);
    }

    removeEventListener(listener: VehicleController.EventListener): void {
        this.eventListeners.removeListener(listener);
    }

    pushEvent(event: VehicleController.Event): void {
        this.controllers.forEach(controller => {
            controller.pushEvent(event);
        });
    }
}
